import React from "react";
import { Nav, Logo, NavLink, Bars, NavMenu, NavBtn } from "./HeaderElements";

const Header = ({ toggle }) => {
  return (
    <div className="Container" style={{padding: 0}}>
      <Nav>
        <Logo to="/">
          <img
            src="/33.png"
            alt="logo"
          />
        </Logo>
        <NavMenu>
          <NavLink className="menu-item" to="projects">
            Projects
          </NavLink>
          <NavLink className="menu-item" to="about">
            About
          </NavLink>
          <NavLink className="menu-item" to="contact">
            Contact
          </NavLink>
        </NavMenu>
        <NavBtn>
          <a
            className="btn PrimaryBtn"
            href="https://drive.google.com/file/d/18BYE9xrd6aqJdTobkCoyr23FLPdztyxx/view?usp=drivesdk"
            target="_blank"
            rel="noopener noreferrer"
          >
            Resume
          </a>
          <a
            className="btn PrimaryBtn"
            href="https://ai-chat-bot2-2.onrender.com/"
            target="_blank"
            rel="noopener noreferrer"
          >
            AI Assistant
          </a>
        </NavBtn>
        
        <Bars onClick={toggle} />
      </Nav>
    </div>
  );
};

export default Header;
